










import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import RsLabel from './RsLabel.vue'

@Component({
	name: 'LabelList',
	components: {
		RsLabel,
	},
})
export default class LabelList extends Vue {
	@Prop()
	private list!: any
}
